import React from 'react';
import { useTranslation } from 'react-i18next';

export function GameServerFeatures() {
  const { t } = useTranslation();

  const panelFeatures = t('gameHosting.features.panel.features', { returnObjects: true }) || [];

  return (
    <div className="bg-white rounded-xl shadow-lg p-8 mb-16">
      <h2 className="text-2xl font-bold mb-8 text-center">
        {t('gameHosting.features.title')}
      </h2>

      <div className="grid md:grid-cols-2 gap-8">
        {/* PANEL FEATURES */}
        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-blue-600">
            {t('gameHosting.features.panel.title')}
          </h3>

          <ul className="space-y-2">
            {Array.isArray(panelFeatures) &&
              panelFeatures.map((item: string, index: number) => (
                <li key={index} className="flex items-start">
                  <svg
                    className="w-5 h-5 text-green-500 mr-2 mt-1 flex-shrink-0"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  <span className="text-gray-700">{item}</span>
                </li>
              ))}
          </ul>
        </div>

        {/* BLOCK EXCLUSIVE FOR MINECRAFT */}
        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-blue-600">
            Minecraft Features
          </h3>

          <ul className="space-y-2">
            <li className="flex items-start">
              <svg className="w-5 h-5 text-green-500 mr-2 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
              </svg>
              <span className="text-gray-700">Supporto Java & Bedrock</span>
            </li>

            <li className="flex items-start">
              <svg className="w-5 h-5 text-green-500 mr-2 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
              </svg>
              <span className="text-gray-700">Installatore plugin e modpacks</span>
            </li>

            <li className="flex items-start">
              <svg className="w-5 h-5 text-green-500 mr-2 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
              </svg>
              <span className="text-gray-700">Backup automatici illimitati</span>
            </li>

            <li className="flex items-start">
              <svg className="w-5 h-5 text-green-500 mr-2 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
              </svg>
              <span className="text-gray-700">Pannello Pterodactyl ottimizzato</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
